import entitiesReducer from "./entities";

export default entitiesReducer;
